import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/firestore';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class TShirtsFormsService {

  constructor(private afs: AngularFirestore, private http: HttpClient) { 
  }

  saveUser(user) {
    return this.afs.collection('payments').add(user);
  }

  requestPayment(userId, userValueForm) {
    
    let headers = new HttpHeaders();
    headers = headers.set('x-picpay-token', '70dfa37a-654e-4c61-9c6c-12f6ba341663');

    const httpOptions = {
      headers: headers
    }

    const future = new Date();
    future.setDate(future.getDate() + 30);

    this.http.post("https://appws.picpay.com/ecommerce/public/payments", 
      {
        "referenceId": userId,
        "callbackUrl": "http://www.sualoja.com.br/callback",
        "returnUrl": `https://t-shirts-school-ai.firebaseapp.com/payment-completed/${userId}`,
        "value": 35,
        "expiresAt": future,
        "buyer": {
        "firstName": userValueForm.name,
        "lastName": userValueForm.name,
        "document": userValueForm.cpf,
        "email": userValueForm.email,
        "phone": `+55 ${userValueForm.cellPhone}`
        }
      }, httpOptions).subscribe((response: any) => {
        window.location = response.paymentUrl;
      });
  }

}
